import React, { useRef } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { Layout } from "antd";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import logo from "../../assets/images/logo.png";

//import Sidebar from './Sidebar';
import FooterBar from "./FooterBar";
//import Topnav from './Topnav';
import commonUtility from "../../utility/Utils";
import ProSidebarMenu from "./ProSidebarMenu";
//import ProSidebarMenu from './ProSidebarMenu';
const { Content } = Layout;

const AdminLayout = () => {
  const navigate = useNavigate();
  const mainContentRef = useRef(null);
  const sidebarRef = useRef(null);

  // const handleMenuClick = (url) => {

  //   navigate(url);
  //   window.scrollTo(0, 0)
  // };

  const handleMainContentScroll = () => {
    sidebarRef.current.scrollTop = 0;
  };
  return (
    <div style={{ display: "flex", height: "100%" }}>
      <ProSidebarMenu refrence={sidebarRef} />

      {/* <main style={{ padding: 10 }}> 
      <Outlet key={commonUtility.randomID()} />
    </main> */}
      <Layout
        className="site-layout"
        style={{
          marginLeft: "250px", // Set the left margin to match the width of the sidebar
          minHeight: "100vh",
          overflowX: "auto", // Hide horizontal scrollbar
        }}
        ref={mainContentRef}
        onScroll={handleMainContentScroll}
      >
        <Content
          className="main-content"
          style={{
            width: "100%",
          }}
        >
          <Outlet key={commonUtility.randomID()} />
        </Content>
        <FooterBar />
      </Layout>
    </div>
  );
};

export default AdminLayout;
